import { useEffect, useState } from 'react'
import moment from 'moment'
import { SafeAnchor } from 'react-bootstrap'
import { DynamicCheckout } from '../../../../components'
import { UnleashTheTradingBeastSectionStyle } from '../styles'

export const SMUnleashTheTradingBeast = (props) => {
    let [remainingDays, setRemainingDays] = useState('')
    let [remainingHours, setRemainingHours] = useState('')
    let [remainingMinutes, setRemainingMinutes] = useState('')
    let [remainingSeconds, setRemainingSeconds] = useState('')

    useEffect(() => {
        let parsedDate = Date.parse(props.validUntil)
        let expiry = new Date(parsedDate)
            expiry = moment(expiry).format('MM/DD/yyyy h:mm:ss')

        const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;

        let today = new Date(),
            dd = String(today.getDate()).padStart(2, "0"),
            mm = String(today.getMonth() + 1).padStart(2, "0"),
            yyyy = today.getFullYear(),
            nextYear = yyyy + 1,
            dayMonth = moment(expiry).format('MM/DD/')
    
        today = mm + "/" + dd + "/" + yyyy
        if (today > expiry) {
            expiry = dayMonth + nextYear
        }

        const countDown = new Date(expiry).getTime()
        const x = setInterval(function() {    
            const now = new Date().getTime(),
                distance = countDown - now

            setRemainingDays(Math.floor(distance / (day)))
            setRemainingHours(Math.floor((distance % (day)) / (hour)))
            setRemainingMinutes(Math.floor((distance % (hour)) / (minute)))
            setRemainingSeconds(Math.floor((distance % (minute)) / second))

            if (distance < 0) {
                clearInterval(x)
            }
            //seconds
        }, 1000)
        
        return () => clearInterval(x)
    }, [])

    return (
        <UnleashTheTradingBeastSectionStyle>
            <div className='container'>
                <h2 className='section-title'>
                    <span>Now It's Your Turn To <span className='em'>Unleash The Trading Beast</span></span>
                </h2>
                <p><strong>Act now</strong> and secure this offer before it's too late. <strong className='daily-rate'>&lt;$5 per day</strong> could change your life just like it did for the greats that came before you.</p>
                <p>3 months usually costs $799! But for <strong>just $899 you get 6 months access + bonus items!</strong></p>

                <h3>This price ends in</h3>
                <div className='offer-validity-timer'>
                    <ul>
                        <li>
                            <span id='b-days' className='counter'>{parseInt(remainingDays) < 10 ? '0': ''}{remainingDays}</span>
                            <small>DAYS</small>
                        </li>
                        <li>
                            <span id='b-hours' className='counter'>{parseInt(remainingHours) < 10 ? '0': ''}{remainingHours}</span>
                            <small>HOURS</small>
                        </li>
                        <li>
                            <span id='b-minutes' className='counter'>{parseInt(remainingMinutes) < 10 ? '0': ''}{remainingMinutes}</span>
                            <small>MINUTES</small>
                        </li>
                        <li>
                            <span id='b-seconds' className='counter'>{parseInt(remainingSeconds) < 10 ? '0': ''}{remainingSeconds}</span>
                            <small>SECONDS</small>
                        </li>
                    </ul>
                </div>

                <div className='checkout-btn'>
                    <DynamicCheckout 
                        text="Secure My Offer"
                        position="centered" 
                        userInfo={props.userInfo} 
                        offer={props.subscriptionPlan} />
                </div>

                <p className='little-note'>Note: Crypto payments are welcome, please <SafeAnchor href="https://www.profitfarmers.com/crypto-payment/" rel="noreferrer">contact our support team directly to organize this</SafeAnchor></p>
            </div>
        </UnleashTheTradingBeastSectionStyle>
    )
}